export default __webpack_public_path__ + "static/media/receipt.183ebaeb.svg";